/* ============================================================
   ÉKO '77 — Shop toolbar

   Sorting itself needs NO JavaScript. The desktop control is a
   <form method="get"> with a <select name="sort_by">, and every
   option in the phone sheet is a real submit button — so the sort
   is a normal navigation, the state is the URL, and Shopify does
   the ordering. With scripting off the form still works (the
   <noscript> submit button appears beside the select).

   This file adds exactly two conveniences:
     1. the select submits on change instead of waiting for a button;
     2. the phone sheet opens and closes.

   Deliberately NOT Dawn's facets.js: FacetFiltersForm re-renders
   #ProductGridContainer and reads document.getElementById('product-grid'),
   both of which belong to Dawn's grid section. The ÉKO grid task
   (378c1e0f) replaces that section, and a sort control that throws the
   moment the grid is swapped is worse than one that navigates.
   ============================================================ */

(function () {
  'use strict';

  var CLOSE_MS = 280;

  if (typeof customElements === 'undefined' || !window.HTMLElement) return;

  class ShopToolbar extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this.sheet = this.querySelector('[data-x-toolbar-sheet]');
      this.openBtn = this.querySelector('[data-x-toolbar-open]');
      this.select = this.querySelector('[data-x-toolbar-select]');

      this.onSelect = this.onSelect.bind(this);
      this.onSheetClick = this.onSheetClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.open = this.open.bind(this);
      this.close = this.close.bind(this);

      if (this.select) this.select.addEventListener('change', this.onSelect);
      if (this.openBtn) this.openBtn.addEventListener('click', this.open);
      if (this.sheet) this.sheet.addEventListener('click', this.onSheetClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      this.release();
    }

    /* ---------------- sorting ---------------- */

    onSelect() {
      var form = this.select.form;
      if (!form) return;
      // a slow connection should not let a second choice race the first
      this.select.setAttribute('aria-busy', 'true');
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    /* ---------------- the phone sheet ---------------- */

    open() {
      if (!this.sheet) return;
      this.sheet.hidden = false;
      this.sheet.setAttribute('aria-hidden', 'false');
      if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'true');
      this.lock();
      var sheet = this.sheet;
      requestAnimationFrame(function () {
        sheet.classList.add('is-on');
      });
      var first = this.sheet.querySelector('.x-toolbar__opt.is-on, .x-toolbar__opt');
      if (first) first.focus({ preventScroll: true });
    }

    close() {
      if (!this.sheet || this.sheet.hidden) return;
      var sheet = this.sheet;
      sheet.classList.remove('is-on');
      if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'false');
      this.release();
      clearTimeout(this._t);
      this._t = setTimeout(function () {
        sheet.hidden = true;
        sheet.setAttribute('aria-hidden', 'true');
      }, CLOSE_MS);
      if (this.openBtn) this.openBtn.focus({ preventScroll: true });
    }

    onSheetClick(event) {
      if (event.target.closest('[data-x-toolbar-close]')) this.close();
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.sheet && !this.sheet.hidden) this.close();
    }

    /* the reference locks <body> while the sheet is up; do it without
       clobbering a lock another ÉKO overlay (nav panel, basket) already set */
    lock() {
      if (document.body.style.overflow === 'hidden') return;
      this._locked = true;
      document.body.style.overflow = 'hidden';
    }

    release() {
      if (!this._locked) return;
      this._locked = false;
      document.body.style.overflow = '';
    }
  }

  if (!customElements.get('x-shop-toolbar')) {
    customElements.define('x-shop-toolbar', ShopToolbar);
  }
})();
